<template>
  <li>
    <div class="d-flex py-2">
      <div>
        <img :src="src" width="60" height="60">
      </div>
      <div class="flex-grow-1 ml-2">
        {{ name }}<span v-if="!removeInputs" class="info">, sku: {{ sku }}</span>
        <div :class="{hasError}">
          <span v-if="!removeInputs">
            <template v-if="!removePrice">
              Prijs: €
              <input v-model.number="newPrice" type="number" ref="price">
            </template>
            Hoeveelheid:
            <input v-if="!disableQtyInput" v-model.number="newQty" type="number">
            <span v-else>
              {{ newQty }} <span style="opacity: .5;font-size: 12px">(Alleen van nieuwe bundelproducten kan het aantal worden gewijzigd.)</span>
            </span>
          </span>
          <span v-else class="info">
            Sku: {{ sku }}
          </span>

          <template v-if="!removeInputs">
            <span v-if="!isValidPrice">
              Price must be numeric.
            </span>
            <span v-else-if="!isValidQuantity">
              Quantity must be an integer.
            </span>
          </template>
        </div>
      </div>
    </div>

    <svg class="close" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor" @click="$emit('close')">
      <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
    </svg>
  </li>
</template>

<script>

import { required } from "vuelidate/lib/validators"

export default {
  props: {
    disableQtyInput: Boolean,
    sku: String,
    src: String,
    name: String,
    error: Boolean,
    removeInputs: Boolean,
    removePrice: Boolean,

    price: [Number, String],
    qty: [Number, String],
  },
  mounted() {
    this.$refs.price && this.$refs.price.focus()
  },
  validations: {
    newPrice: {
      required,
    },
    newQty: {
      required,
    },
  },
  data() {
    return {
      newPrice: this.price,
      newQty: this.qty,
    }
  },
  computed: {
    isValidPrice() {
      return typeof this.$v.newPrice.$model === "number"
    },
    isValidQuantity() {
      const qty = this.$v.newQty.$model
      return typeof qty === "number" && !(qty + "").includes('.') && !(qty + "").includes(',')
    },
    hasError() {
      return !this.isValidPrice || !this.isValidQuantity
    },
  },
  watch: {
    price(val) {
      this.newPrice = val
    },
    qty(val) {
      this.newQty = val
    },
    newPrice(val) {
      this.$emit("update:price", val)
    },
    newQty(val) {
      this.$emit("update:qty", val)
    },
  },
}

</script>

<style scoped>

li {
  position: relative;
  list-style: none;
  cursor: pointer;
}

li + li > div {
  border-top: 1px solid #ebebeb !important;
}

.close {
  position: absolute;
  right: 0;
  top: 0;
}

.hasError input {
  border: 1px solid #FF4A55;
}

.hasError span {
  color: #FF4A55;
}

.info {
  color: #96999c;
}

img {
  border-radius: 8px;
  border: 1px solid #E3E3E3;
}

input {
  border: 1px solid #E3E3E3;
  width: 80px;
  border-radius: 1px;
  padding: 0px 0;
  padding-left: 6px;
  padding-right: 6px;
}

</style>
